import { FormEvent, useState } from 'react';
import { Button, FormControl, Label, Well } from 'react-bootstrap';
import { IConnectToDonorStatus } from '@nkr/models/connect-to-donor-status';
import { ICounselor, showFilters } from './models';
import { IMicrositeRecipient } from '@nkr/models/index';
import { Typeahead } from 'react-bootstrap-typeahead';

interface IProps {
    userFilter: number,
    statusFilter: number,
    showFilter: number,
    searchFilter: string,
    micrositeRecipient: number,
    userList: ICounselor[],
    statusList: IConnectToDonorStatus[],
    micrositeRecipientList: IMicrositeRecipient[],
    isRestrictedToAssigned: boolean,
    onChange: (property: string, value: any) => void,
    onSubmit: (reset: boolean) => void
}

const Filters = (props: IProps) => {
    
    const handleFilterChange = (e: FormEvent<FormControl & HTMLSelectElement & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        props.onChange(name, e.currentTarget.value);
    };

    const handleSetRecipient = (selection: IMicrositeRecipient[]) => {
        let id = 0;

        if (selection.length > 0) {
            id = selection[0].id;
        }

        props.onChange('micrositeRecipient', id);
    }

    const { userFilter, statusFilter, showFilter, searchFilter, micrositeRecipient, userList, statusList, isRestrictedToAssigned } = props;

    const micrositeRecipientChosen = props.micrositeRecipientList.filter(x => x.id == micrositeRecipient);

    return (
        <Well bsSize='sm' style={{ marginBottom: 5 }}>
            <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                {!isRestrictedToAssigned && (
                    <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                        <div style={{ fontSize: 12, marginRight: 5 }}>Mentor:</div>
                        <FormControl
                            componentClass='select'
                            name='userFilter'
                            bsSize='sm'
                            value={userFilter}
                            onChange={handleFilterChange}
                        >
                            <option value={-1}>- Any Mentor -</option>
                            <option value={-2}>- Unassigned Only -</option>
                            {userList.map((item, index) =>
                                <option key={`ctr-${index}`} value={item.id}>{item.lastName}, {item.firstName}</option>
                            )}
                        </FormControl>
                    </div>
                )}

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ fontSize: 12, marginRight: 5 }}>Status:</div>
                    <FormControl
                        componentClass='select'
                        name='statusFilter'
                        bsSize='sm'
                        value={statusFilter}
                        onChange={handleFilterChange}
                    >
                        <option value={-1}>- Any Status -</option>
                        {statusList.map((item, index) =>
                            <option key={`ctr-${index}`} value={item.id}>{item.description}</option>
                        )}
                    </FormControl>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ fontSize: 12, marginRight: 5 }}>Show:</div>
                    <FormControl
                        componentClass='select'
                        name='showFilter'
                        bsSize='sm'
                        value={showFilter}
                        onChange={handleFilterChange}
                    >
                        {showFilters.map((filter, index) =>
                            <option key={`ctr-${index}`} value={filter.value}>{filter.description}</option>
                        )}
                    </FormControl>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ fontSize: 12, marginRight: 5 }}>Microsite&nbsp;Patient:</div>
                        <Typeahead
                            id='nkr-microsite-recipient'
                            clearButton={true}
                            labelKey={(option) => {
                                return option.fullName;
                            }}
                            options={props.micrositeRecipientList}
                            selected={micrositeRecipientChosen}
                            filterBy={['fullName']}
                            renderMenuItemChildren={(option, props) => {
                                return (
                                    <div>
                                        {option.fullName != '' ?
                                            <div>{option.fullName}</div>
                                            :
                                            <div><Label>name not specified</Label></div>
                                        }
                                    </div>
                                );
                            }}
                            placeholder='- Patient -'
                            onChange={handleSetRecipient}
                        />
                </div>

                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                    <div style={{ fontSize: 12, marginRight: 5 }}>Search:</div>
                    <FormControl
                        value={searchFilter}
                        name='searchFilter'
                        bsSize='sm'
                        style={{ width: 135 }}
                        placeholder='At least 2 characters...'
                        onChange={handleFilterChange}
                    />
                </div>

                <Button bsStyle='primary' bsSize='sm' onClick={() => props.onSubmit(false)}>Refresh List</Button>&nbsp;

                
            </div>
        </Well>
    );
}

export default Filters;